import React from 'react';

export const GeoZone = ({ getZone, geoRegionInZone, handleZone }) => {
  return (
    <div className="container p-0 mt-4">
      {geoRegionInZone && (
        <label className="h5 mb-2">Zone:</label>
      )}
      <div className="form-group d-flex flex-wrap align-items-stretch">
        {geoRegionInZone &&
          geoRegionInZone &&
          React.Children.toArray(
            geoRegionInZone?.map((zone) => (
              <>
                <div
                  className={`button-belair col-6 mb-0 mt-0 break-word ${
                    // eslint-disable-next-line eqeqeq
                    getZone == zone?.id ? 'blend' : ''
                  }`}
                  onClick={handleZone}
                  data-zone={zone?.id}
                >
                  {zone?.text}
                </div>
              </>
            )),
          )}
      </div>
    </div>
  );
};
